// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withRouter } from 'next/router';
import hoistNonReactStatic from 'hoist-non-react-statics';
import withDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import PointsClaimSaga from '@tcp/core/src/components/features/account/PointsClaim/container/PointsClaim.saga';
import PointsClaimReducer from '@tcp/core/src/components/features/account/PointsClaim/container/PointsClaim.reducer';
import EarnExtraPointsTileSaga from '@tcp/core/src/components/features/account/common/organism/EarnExtraPointsTile/container/EarnExtraPointsTile.saga';
import EarnExtraPointsTileReducer from '@tcp/core/src/components/features/account/common/organism/EarnExtraPointsTile/container/EarnExtraPointsTile.reducer';
import PaymentReducer from '@tcp/core/src/components/features/account/Payment/container/Payment.reducer';
import PaymentSaga from '@tcp/core/src/components/features/account/Payment/container/Payment.saga';
import DeleteCardSaga from '@tcp/core/src/components/features/account/Payment/container/DeleteCard.saga';
import DefaultPaymentSaga from '@tcp/core/src/components/features/account/Payment/container/DefaultPayment.saga';
import BillingPaymentSaga from '@tcp/core/src/components/features/CnC/Checkout/organisms/BillingPaymentForm/container/CreditCard.saga';
import MyAccountLayout from '../views/MyAccountLayout.view';
import AccountComponentMapping from '../AccountComponentMapping';
import accountPageNameMapping from '../AccountPageNameMapping';
import utils, { routerPush } from '../../../../../utils';
import { getAccountNavigationState, getAccountRichTextContent } from './Account.selectors';
import { getAccountNavigationList, initActions, getModuleXContent } from './Account.actions';
import { getUserLoggedInState, isRememberedUser } from '../../User/container/User.selectors';
import { trackPageView, setClickAnalyticsData } from '../../../../../analytics/actions';
import {
  getIsBIAEnabled,
  getIsAccountPageRAR,
  isPlacePerkEnabled,
  getIsBIABagPageCustomVariableEnabled,
  getIsGuestFavEnabled,
  getAddPickUpPersonEnabled,
} from '../../../../../reduxStore/selectors/session.selectors';
import { getBuyItAgainBagPageProducts } from '../../../CnC/BuyItAgainBagPage/container/BuyItAgainBagPage.actions';
import AccountSagas from './Account.saga';
import AccountReducers from './Account.reducer';
import BuyItAgainDynamicStore from '../../BuyItAgain/container/BuyItAgainDynamicStore';
import { getDynamicLabelValues } from '../../../../../utils/labels/labelUtilty';
import { isShowSuccessMessage } from '../../OrderDetails/organism/AddPickupPerson/container/AddPickUpPersonForm.selectors';
import { showSuccessMessage } from '../../OrderDetails/organism/AddPickupPerson/container/AddPickUpPersonForm.actions';
import InformationHeaderView from '../../OrderDetails/organism/AddPickupPerson/organisms/InformationHeader.view';
import GlobalErrorComponentContainer from '../../../../common/molecules/GlobalErrorComponent/container/GlobalErrorComponent.container';
/**
 * @function Account The Account component is the main container for the account section
 * This component includes the layout view, it passes the MyAccountLayout with the mainContent to be rendered
 * on th right side.
 * NOTE: Which ever new component that gets added for left nav, needs an entry in AccountComponentMapping file.
 * @param {router} router Router object to get the query key
 */

const excludeRouteMapping = ['/TrackOrder'];
const accountPagesMapping = [
  'account-overview',
  'place-rewards',
  'wallet',
  'extra-points',
  'orders',
  'profile',
  'address-book',
  'payment',
  'my-preference',
  'rewardsCreditCard',
  'favorites',
  'buy-it-again',
  'rate-review',
];

const DEFAULT_ACTIVE_COMPONENT = 'account-overview';
export class Account extends React.PureComponent {
  constructor(props) {
    super(props);
    const activeComponent = utils.getObjectValue(
      props.router,
      DEFAULT_ACTIVE_COMPONENT,
      'query',
      'id'
    );
    this.state = {
      componentToLoad:
        utils.getObjectValue(props.router, undefined, 'query', 'subSection') || activeComponent,
      activeComponent,
    };
    this.isAcountModuleXfetched = false;
  }

  async componentDidMount() {
    const {
      getAccountNavigationAction,
      getAccountModuleXContent,
      accountRichTextContent,
      isUserLoggedIn,
      getBIABagPageProducts,
      isBIAABCustomVariableEnabled,
    } = this.props;
    getAccountNavigationAction();
    if (getDynamicLabelValues('account.common') && !accountRichTextContent) {
      getAccountModuleXContent(getDynamicLabelValues('account.common').referred);
    }

    if (isBIAABCustomVariableEnabled && isUserLoggedIn) {
      await BuyItAgainDynamicStore();
      getBIABagPageProducts();
    }
    this.triggerPageLoadEvent();
  }

  componentWillUnmount() {
    const { setShowSuccessMsgAction } = this.props;
    setShowSuccessMsgAction(false);
  }

  componentDidUpdate(prevProps, prevState) {
    const { componentToLoad } = this.state;
    const {
      getAccountModuleXContent,
      accountRichTextContent,
      isUserLoggedIn,
      router,
      isGuestFavEnabled,
    } = this.props;
    const checkForGuestFavView =
      !isUserLoggedIn && isGuestFavEnabled && router?.query?.id === 'favorites';
    const { pathname } = (window && window.location) || {};

    if (
      isUserLoggedIn === false &&
      !excludeRouteMapping.includes(router.route) &&
      !checkForGuestFavView
    ) {
      routerPush(`/home?target=login&successtarget=${pathname}`, '/home/login');
    }

    this.fetchAccountModuleXContent(getAccountModuleXContent, accountRichTextContent);

    if (this.activePageRef && prevState.componentToLoad !== componentToLoad) {
      const focusUpdate =
        (accountPagesMapping.includes(prevState.componentToLoad) &&
          accountPagesMapping.includes(componentToLoad)) ||
        (accountPagesMapping.includes(prevState.componentToLoad) &&
          !accountPagesMapping.includes(componentToLoad));
      if (focusUpdate) {
        this.activePageRef.blur();
        const focusTimer = setTimeout(() => {
          this.activePageRef.focus({ preventScroll: true });
          utils.scrollPage();
          clearTimeout(focusTimer);
        }, 100);
      }
      this.triggerPageLoadEvent();
    }
  }

  /**
   * Set the wrapper ref
   */
  setPageRef = (ref) => {
    this.activePageRef = ref;
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const nextActiveComponent = utils.getObjectValue(
      nextProps.router,
      DEFAULT_ACTIVE_COMPONENT,
      'query',
      'id'
    );
    const nextComponent =
      utils.getObjectValue(nextProps.router, undefined, 'query', 'subSection') ||
      nextActiveComponent;
    const prevComponent = prevState.componentToLoad;
    if (nextComponent !== prevComponent) {
      return { componentToLoad: nextComponent, activeComponent: nextActiveComponent };
    }
    return null;
  }

  fetchAccountModuleXContent = (getAccountModuleXContent, accountRichTextContent) => {
    const referredValue = getDynamicLabelValues('account.common.referred');
    if (!accountRichTextContent && !this.isAcountModuleXfetched && referredValue) {
      this.isAcountModuleXfetched = true;
      getAccountModuleXContent(referredValue);
    }
  };

  triggerPageLoadEvent = () => {
    const { componentToLoad } = this.state;
    const { router, trackPageLoad } = this.props;
    const { pageNavigationText = '', pageName = '' } =
      accountPageNameMapping[componentToLoad] || {};
    const { query } = router;
    const eventData =
      router?.query?.id === 'buy-it-again' ? { customEvents: ['event62'], metric62: '1' } : null;
    if (!query.fromOrderHelp) {
      trackPageLoad({
        ...eventData,
        path: router && router.asPath,
        pageNavigationText,
        props: {
          initialProps: {
            pageProps: {
              pageData: {
                pageName,
                pageSection: 'myplace',
                pageSubSection: 'myplace',
                pageType: 'myplace',
              },
            },
          },
        },
      });
    }
  };

  /**
   * @function render  Used to render the JSX of the component
   * @param    {[Void]} function does not accept anything.
   * @return   {[Object]} JSX of the component
   */
  render() {
    const { componentToLoad, activeComponent } = this.state;
    const {
      router,
      accountNavigation,
      isUserLoggedIn,
      isBIAEnabled,
      isRAREnabled,
      placePerkEnabled,
      isRemembered,
      isGuestFavEnabled,
      isShowSuccessMessageState,
      setShowSuccessMsgAction,
      isAddAltPickupPersonEnabled,
    } = this.props;
    let navData = [];
    if (accountNavigation) {
      navData = accountNavigation.accountNav;
    }
    const checkForGuestFavView =
      !isUserLoggedIn &&
      isGuestFavEnabled &&
      router?.query?.id === 'favorites' &&
      isUserLoggedIn !== null;
    const fromTrackOrder = router?.route === '/TrackOrder';

    // TODO: currently our views are breaking if account labels are not present
    // so rendering MyAccountLayout only when labels are present
    // later on we can either need to add loader or we can prevent rendering from
    // _app.jsx itself.
    if (
      isUserLoggedIn ||
      (componentToLoad === 'order-details' &&
        isUserLoggedIn !== null &&
        (!isRemembered || excludeRouteMapping.includes(router.route))) ||
      checkForGuestFavView
    ) {
      return (
        <>
          <GlobalErrorComponentContainer />
          {isShowSuccessMessageState && isAddAltPickupPersonEnabled && (
            <InformationHeaderView
              isShowSuccessMessageState={isShowSuccessMessageState}
              closeAction={setShowSuccessMsgAction}
              fromTrackOrder={fromTrackOrder}
            />
          )}
          <MyAccountLayout
            mainContent={AccountComponentMapping[componentToLoad]}
            active={activeComponent}
            activeSubComponent={componentToLoad}
            navData={navData}
            router={router}
            pageContentRef={this.setPageRef}
            isUserLoggedIn={isUserLoggedIn}
            isBIAEnabled={isBIAEnabled}
            isRAREnabled={isRAREnabled}
            isPlacePerkEnabled={placePerkEnabled}
            isGuestFav={checkForGuestFavView}
          />
        </>
      );
    }

    return null;
  }
}

Account.getInitActions = () => initActions;

Account.getInitialProps = (reduxProps, pageProps, query) => {
  const componentToLoad = utils.getObjectValue(reduxProps, DEFAULT_ACTIVE_COMPONENT, 'query', 'id');
  return {
    ...pageProps,
    ...{
      pageData: {
        pageName: accountPageNameMapping[componentToLoad]
          ? accountPageNameMapping[componentToLoad].pageName
          : '',
        pageSection: 'myplace',
        pageSubSection: 'myplace',
        loadAnalyticsOnload: false,
      },
    },
    query,
  };
};

Account.pageInfo = {
  pageId: 'Account',
};

export const mapDispatchToProps = (dispatch) => {
  return {
    setShowSuccessMsgAction: (payload) => {
      dispatch(showSuccessMessage(payload));
    },
    getAccountNavigationAction: () => {
      dispatch(getAccountNavigationList());
    },
    getAccountModuleXContent: (referred) => {
      dispatch(getModuleXContent(referred));
    },
    trackPageLoad: (payload) => {
      const customEvents = payload?.customEvents || [];
      customEvents.push('event80');
      dispatch(
        setClickAnalyticsData({
          customEvents,
          pageNavigationText: payload.pageNavigationText,
          supressProps: ['eVar97'],
        })
      );
      dispatch(trackPageView(payload));
      const analyticsTimer = setTimeout(() => {
        dispatch(setClickAnalyticsData({}));
        clearTimeout(analyticsTimer);
      }, 100);
    },
    getBIABagPageProducts: () => dispatch(getBuyItAgainBagPageProducts()),
  };
};

const mapStateToProps = (state) => {
  return {
    accountNavigation: getAccountNavigationState(state),
    isUserLoggedIn: getUserLoggedInState(state),
    accountRichTextContent: getAccountRichTextContent(state),
    isBIAEnabled: getIsBIAEnabled(state),
    isRAREnabled: getIsAccountPageRAR(state),
    placePerkEnabled: isPlacePerkEnabled(state),
    isBIAABCustomVariableEnabled: getIsBIABagPageCustomVariableEnabled(state),
    isRemembered: isRememberedUser(state),
    isGuestFavEnabled: getIsGuestFavEnabled(state),
    isShowSuccessMessageState: isShowSuccessMessage(state),
    isAddAltPickupPersonEnabled: getAddPickUpPersonEnabled(state),
  };
};

Account.propTypes = {
  getAccountNavigationAction: PropTypes.func.isRequired,
  router: PropTypes.shape({}).isRequired,
  accountNavigation: PropTypes.shape([]).isRequired,
  isUserLoggedIn: PropTypes.bool.isRequired,
  trackPageLoad: PropTypes.func,
  getAccountModuleXContent: PropTypes.func,
  accountRichTextContent: PropTypes.shape({}),
  isGuestFavEnabled: PropTypes.bool,
};

Account.defaultProps = {
  trackPageLoad: () => {},
  getAccountModuleXContent: () => {},
  accountRichTextContent: {},
  isGuestFavEnabled: false,
};

const withReducer = withDynamicReducer([
  { key: 'PaymentReducer', reducer: PaymentReducer },
  { key: 'PointsClaimReducer', reducer: PointsClaimReducer },
  { key: 'AccountReducer', reducer: AccountReducers },
  { key: 'earnExtraPointsReducer', reducer: EarnExtraPointsTileReducer },
]);

const withSaga = withDynamicSaga([
  { key: 'AccountSaga', saga: AccountSagas },
  { key: 'PaymentSaga', saga: PaymentSaga },
  { key: 'DeleteCardSaga', saga: DeleteCardSaga },
  { key: 'DefaultPaymentSaga', saga: DefaultPaymentSaga },
  { key: 'BillingPaymentSaga', saga: BillingPaymentSaga },
  { key: 'PointsClaimSaga', saga: PointsClaimSaga },
  { key: 'EarnExtraPointsTileSaga', saga: EarnExtraPointsTileSaga },
]);
const withConnect = connect(mapStateToProps, mapDispatchToProps);
const connectWrapper = compose(withReducer, withSaga, withConnect)(Account);

const AccountWithWrapper = withRouter(connectWrapper);

hoistNonReactStatic(AccountWithWrapper, connectWrapper, {
  getInitialProps: true,
});

export default AccountWithWrapper;
